/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
//   $("#checkbox").attr("checked", true);
//   var $stock = $('#sidebar-filter-v-availability0').attr('checked');
//   console.log('$stock',$stock);
//   $('#sidebar-filter-v-availability0').click(function(){
//     $stock = $('#sidebar-filter-v-availability0').attr('checked');
//     console.log('$stock',$stock);
//     if($stock){
//       $('body').addClass('filter_no_stock');
//     }else{
//       $('body').removeClass('filter_no_stock');
//     }    
//   });
});


$(document).ready(function(){
  $(".sizechart_btn").click(function(){
    $("html").addClass("no-scroll");
    $(".PageOverlay").addClass("is-visible");
    $(".sizechart-popup").addClass("active");
  });
  $(".PageOverlay, .clsoe_icon").click(function(){
    $("html").removeClass("no-scroll");
    $(".PageOverlay").removeClass("is-visible");
    $(".sizechart-popup").removeClass("active");
  });
});


$(document).ready(function(){
  $(".clickColor").on("click",function(e){
    e.preventDefault();
  	var dataImgUrl = $(this).attr("data-img-url");
    var dataUrl = $(this).attr("dataUrl");
   $(this).closest(".ProductItem__Wrapper").find(".AspectRatio").find("img").attr("srcset",dataImgUrl);  
   $(this).closest(".ProductItem__Wrapper").find("a").attr("href",dataUrl); 
   //$(this).closest(".ProductItem__Info").find(".ProductItem__Title").find("a").text(title);
   $(this).parent().addClass("active").siblings().removeClass("active"); 
  })
})